function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.473 10.285l.48-2.236H1.856A1.857 1.857 0 010 6.192V4.301c0-.385.09-.764.261-1.108l1.083-2.165A1.857 1.857 0 013.004.002h8.758C12.446.002 13 .556 13 1.24v4.952c0 .684-.554 1.238-1.238 1.238H9.905l-2.756 4.41a1.156 1.156 0 01-.98.543 1.734 1.734 0 01-1.696-2.098zm5.432-4.093h1.857V1.24H9.905v4.952zM2.45 1.582a.619.619 0 01.554-.342h5.662v5.835l-2.542 4.068a.496.496 0 01-.441-.598l.479-2.236a1.238 1.238 0 00-1.21-1.498H1.856a.619.619 0 01-.619-.619V4.301c0-.192.045-.382.13-.554l1.083-2.165z"
}));